import styled from 'styled-components';
export var Span = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__Span",
  componentId: "sc-13fp9fw-0"
})(["background-color:", ";border-radius:16px;color:", ";display:inline-flex;font-family:", ";font-size:", ";letter-spacing:0.1px;padding:", ";align-items:center;"], function (_ref) {
  var bgColor = _ref.bgColor;
  return bgColor;
}, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.spacing.sp2, " ").concat(theme.spacing.sp8);
});
export var TagList = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__TagList",
  componentId: "sc-13fp9fw-1"
})(["display:flex;", " + ", "{margin-left:", ";}"], Span, Span, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.spacing.sp4);
});